import React, { FC } from "react";
import cx from "classnames";
import { format } from "date-fns";
import { useTranslation } from "i18n";
import { getTootlipProps, Tooltip } from "component-library";
import { DatesFormat } from "shared-types";
import { ReactComponent as InfoIcon } from "component-library/src/images/svg/icons/info.svg";

interface Props {
  reason?: string;
  closeDate?: string;
  className?: string;
}

const BreakdownClosedEarlyLabel: FC<Props> = ({
  className,
  reason = "",
  closeDate = Date.now(),
}) => {
  const { t } = useTranslation();
  const dateObject = new Date(closeDate);
  const dateTime = {
    date: format(dateObject, DatesFormat.dateFormatPrimary),
    time: format(dateObject, DatesFormat.timeFormatPrimary),
  };

  return (
    <div className={cx("flex items-center gap-2", className)}>
      {t("common:breakdown.closedEarly.label")}
      <Tooltip
        {...getTootlipProps(
          t("common:breakdown.closedEarly.tooltip", dateTime),
          t("common:breakdown.closedEarly.reason", {
            reason,
          })
        )}
      >
        <InfoIcon height={16} width={16} className="text-color-brand-one" />
      </Tooltip>
    </div>
  );
};

export default BreakdownClosedEarlyLabel;
